import api from '../utils/axiosConfig'
import { useState, useCallback, useEffect } from 'react'
import { StatMosquito } from '../types/stat-mosquito.ts' // 使用导入的类型，删除本地定义

// 缓存设置
const CACHE_TTL = 60000 // 1分钟缓存
let cachedRecords: StatMosquito[] | null = null
let lastFetchTime = 0

export const clearStatMosquitoCache = (): void => {
    cachedRecords = null
    lastFetchTime = 0
}

/**
 * 获取历史记录
 * 支持可选的类型过滤和强制刷新缓存
 */
export const getHistoryRecords = async (
    type?: number,
    forceRefresh = false
): Promise<StatMosquito[]> => {
    try {
        // 检查缓存是否有效
        if (
            !forceRefresh &&
            cachedRecords &&
            Date.now() - lastFetchTime < CACHE_TTL
        ) {
            // 如果请求特定类型，过滤缓存结果
            if (type) {
                return cachedRecords.filter((record) => record.type === type)
            }
            return cachedRecords
        }

        // 根据是否有type参数决定API路径
        const endpoint = '/stat-mosquito/'
        const params = type ? { type } : undefined
        const response = await api.get(endpoint, { params })

        cachedRecords = response.data
        lastFetchTime = Date.now()
        return response.data
    } catch (error) {
        console.error('获取历史记录失败:', error)
        return []
    }
}


/**
 * React Hook: 使用历史记录
 */
export const useHistory = (type?: 1 | 2 | 3) => {
    const [records, setRecords] = useState<StatMosquito[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const fetchRecords = useCallback(
        async (forceRefresh = false) => {
            setLoading(true)
            setError(null)
            try {
                // 确保传递正确的参数
                const data = await getHistoryRecords(type, forceRefresh)
                setRecords(data)
            } catch (error) {
                console.error('获取历史记录失败:', error)
                setError('无法加载历史记录')
            } finally {
                setLoading(false)
            }
        },
        [type]
    )

    useEffect(() => {
        fetchRecords(false)
    }, [fetchRecords])



    return {
        records,
        loading,
        error,
        refreshRecords: fetchRecords,
    }
}
